export default __webpack_public_path__ + "static/media/code.d812f44b.png";